import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGetSingleServerQuery, useVoteServerMutation } from '../RTK/ApiRequests';
import { useLocation, NavLink, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import moment from 'moment';
import Loader from '../components/Loader';

const SpecificServer = ({ isAuthourized, email }) => {

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const serverId = queryParams.get('serverId');

  const [status, setStatus] = useState({});
  const [voteUserName, setVoteUserName] = useState('');
  const [indices, setIndices] = useState(0);
  const [ip, setIp] = useState({});
  const [voteDiv, setVoteDiv] = useState(false);
  const [isVoted, setIsVoted] = useState(false);
  const [remainingTime, setRemainingTime] = useState('');
  const [voteData, setVoteData] = useState({})
  
  const { data, isLoading, isError } = useGetSingleServerQuery(serverId);
  const [voteServer] = useVoteServerMutation();

  const getStatus = async () => {
    await fetch('https://api.mcstatus.io/v2/status/java/' + data?.server?.ip + ':' + data?.server?.serverPort).then((response) => {
      return response.json();
    }).then((data) => {
      setStatus(data);
    }).catch((err) => {
      console.log(err);
    });
  };

  const calculateRemainingTime = () => {
    const cookie = Cookies.get(data?.server?.serverID + 't_e_v');
    if (cookie) {
      const expirationDate = moment(cookie, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
      const currentDate = moment();
      const diff = expirationDate.diff(currentDate);
      const duration = moment.duration(diff);
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      setRemainingTime(`${hours}h ${minutes}m ${seconds}s`);
    }
  };

  function getCookiesWithLetter(letter) {
    const cookies = document.cookie.split('; ');
    const indices = [];
  
    cookies.forEach((cookie, index) => {
      const cookieName = cookie.split('=')[0]; 
      if (cookieName.includes(letter)) {
        indices.push(index);
      }
    });
  
    return indices.length;
  }
  
  useEffect(() => {
    getStatus();
    setIndices(getCookiesWithLetter('t_e_v'));

    if (Cookies.get(data?.server?.serverID + 't_e_v')) {
      setIsVoted(true);
      calculateRemainingTime();
    } else {
      setIsVoted(false);
    }

    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then(async (data) => {
        const ip = await data.ip;
        setIp(ip);
      })
      .catch((err) => {
        console.error(err);
      });

    setVoteData({
      id: data?.server?.serverID,
      votifierIP: data?.server?.votifierIP,
      votifierPort: data?.server?.votifierPort,
      votifierPublicKey: data?.server?.votifierPublicKey
    });

  }, [data]);

  const vote = async () => {
    try {
        const { id, votifierIP, votifierPort, votifierPublicKey } = voteData;

        const queryParams = new URLSearchParams({
            host: votifierIP,
            port: votifierPort || 8192,
            timeout: 5.0,
            username: voteUserName,
            serviceName: 'mcstatus.io',
            timestamp: new Date().toISOString(),
            publickey: votifierPublicKey,
            ip: ip
        });

        const url = `https://api.mcstatus.io/v2/vote?${queryParams.toString()}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain',
            },
        });

        if (!response.ok) {
            alert(`Error: Incorrect Details!`);
            return;
        }

        const responseText = await response.text();

        const res = await voteServer({ serverID: id, email: email });

        if (!res.error) {
            const expirationDate = moment().add(24, 'hours').toISOString();
            Cookies.set(id + 't_e_v', expirationDate, { expires: 1 });
            setIsVoted(true);
            calculateRemainingTime();
            alert('Voted Successfully!');
            window.location.reload();
        } else {
            alert('Something went wrong, Try again later!');
        }

    } catch (err) {
        console.error('Error during voting:', err);
        alert('Something went wrong, Try again later!');
    }
};



  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <Loader />;
  }

  return (
    <SpecificServerWrapper>
      <Info>
        <div className="header-bar box-shadow">
          <div className="text">{data?.server?.serverName}</div>
        </div>
        <div className="info-fields">
          <ServerDetails><strong>Owner:</strong> <span>{data?.server?.Owner}</span></ServerDetails>
          <ServerDetails isOnline={status?.online} ><strong>Status:</strong> <span style={{ color: status?.online ? 'green' : 'red', fontWeight: status?.online ? 'bold' : 'none' }}>{!status?.online ? 'Offline' : 'Online'}</span></ServerDetails>
          <ServerDetails><strong>Java IP:</strong> <span>{data?.server?.ip}</span></ServerDetails>
          <ServerDetails><strong>Port:</strong> <span>{data?.server?.serverPort}</span></ServerDetails>
          {
            !data?.server?.isVote ? null : <ServerDetails><strong>Votes:</strong> <span>{data?.server?.totalVotes}</span></ServerDetails>
          }
          <ServerDetails><strong>Players:</strong> <span>{!status?.online ? '--/--' : status?.players?.online + '/' + status?.players?.max}</span></ServerDetails>
          <ServerDetails><strong>Version:</strong> <span style={{
            backgroundColor: '#58678C',
            padding: '5px',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '5px',
          }}>{!status?.online ? '-.--.-' : status?.version?.name_clean}</span></ServerDetails>
          <ServerDetails><strong>Premium Server:</strong> <span style={{ color: data?.server?.isPremium ? 'green' : 'red', fontWeight: data?.server?.isPremium ? 'bold' : 'none' }}>{!data?.server?.isPremium ? 'No' : 'Yes'}</span></ServerDetails>
          <ServerDetails><strong>Featured Server:</strong> <span style={{ color: data?.server?.isFeatured ? 'green' : 'red', fontWeight: data?.server?.isFeatured ? 'bold' : 'none' }}>{!data?.server?.isFeatured ? 'No' : 'Yes'}</span></ServerDetails>
          <ServerDetails><strong>Posted At:</strong> <span>{data?.server?.createdAt?.slice(0, 10)}</span></ServerDetails>
          <ServerDetails style={{
            alignItems: 'flex-start',
            border: 'none',
          }}><strong>Tags:</strong>
            <div className="tags-det">
              {
                data?.server?.tags?.map((currElem) => {
                  return <NavLink style={{
                    backgroundColor: '#58678C',
                    padding: '5px',
                    color: '#fff',
                    fontWeight: '600',
                    borderRadius: '5px',
                    margin: '5px'
                  }} to={'/servers/?category=' + currElem}>
                    <span>{currElem}</span>
                  </NavLink>
                })
              }</div></ServerDetails>
        </div>
      </Info>
      <MoreDets>
        <div className="header-bar box-shadow">
          <div className="text">{data?.server?.serverName}</div>
        </div>
        <div className="info-fields">
          <img src={data?.server?.bannerImg} alt="banner" />
          <p>{data?.server?.description}</p>
          {
            !isAuthourized ? !data?.server?.isVote ? null : <button onClick={() => {
              navigate('/auth/signIn')
            }}>VOTE FOR THIS SERVER</button> : !data?.server?.isVote ? null : <button onClick={() => {
              setVoteDiv(!voteDiv);
            }}>VOTE FOR THIS SERVER</button>
          }
          {
            !voteDiv ? null : <div className="voteDiv">
              {
                !isAuthourized ? <h4 style={{
                  fontSize: '1.5rem',
                }}>Please Register/Login!</h4> : indices === 5 ? <h4 style={{
                  fontSize: '1.5rem',
                }}>You can only do 5 votes per day!</h4> : !isVoted ? <>
                <input type="username" name='username' placeholder='Username' value={voteUserName} onChange={(e) => {
                  setVoteUserName(e.target.value);
                }} />
                <button onClick={vote}>Vote</button></> : <h4 style={{
                  fontSize: '1.5rem',
                }}>You've already voted this server, you can vote again in {remainingTime}.</h4>
              }
            </div>
          }
        </div>
      </MoreDets>
    </SpecificServerWrapper>
  );
};

const SpecificServerWrapper = styled.section`
  min-height: 100vh;
  padding-bottom: 3rem;

  .header-bar {
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    
    .text {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      color: #fff;
      font-weight: 600;
      background-color: #494949;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-left: 15px;
      position: relative;
      font-size: 1.5rem;
    }
  }

  .box-shadow {
    box-shadow: 0 4px 8px rgba(0, 0, 0, .1);
    border-radius: 0 0 4px 4px;
  }

  min-height: 100vh;
  padding-bottom: 3rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 5rem;
  gap: 10rem;

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    flex-direction: column;
    align-items: center;
  }
`;

const Info = styled.section`
  width: 20%;
  
  .info-fields {
    padding: 1rem;   
  }

  background-color: #fff;
  height: fit-content;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    width: 90%;
  }
`;

const ServerDetails = styled.section`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #C7DCDF;

  strong {
    padding: 1rem;
  }

  span {
    text-align: left;
  }

  .tags-det {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    a {
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &: hover {
        background-color: #4DA421 !important;
      }
    }
  }
`;

const MoreDets = styled.section`
  .header-bar {
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  
  .text {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #fff;
    font-weight: 600;
    background-color: #494949;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    position: relative;
    font-size: 1.5rem;
  }
}

.box-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, .1);
  border-radius: 0 0 4px 4px;
}

  .info-fields {
    padding: 2rem;   
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;

    img {
      width: 100%;
    }

    button {
      padding: 1rem;
      width: 100%;
      color: #fff;
      background-color: #58678C;
      border: none;
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &: hover {
        background-color: #4DA421;
      }
    }

    .voteDiv {
      display: flex;
      gap: 1rem;
      width: 100%;

      input {
        outline: none;
        background-color: #F0F2F6;
        border: 2px solid #58678C;
        border-radius: 4px;
        padding: 10px 40px 10px 15px;
        color: #494949;
        font-size: 16px;
        display: block;
        width: 100%;
        z-index: 1;
        position: relative;
        text-transform: unset;
      }
    }
  }

  height: fit-content;
  background-color: #fff;
  width: 40%;
  border-radius: 5px;

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    width: 90%;
  }
`;

export default SpecificServer
